import { createAsyncThunk } from "@reduxjs/toolkit";
import { forgotPassword as asyncForgetPwd, ResetPassword as asyncResetPassword } from "../../../helpers/apis";
import { showToast } from "../../toast/reducer";

export const forgotPassword = createAsyncThunk(
    'forgotPassword/forgotPassword',
    async (data, thunkAPI) => {
        try {
            const response = await asyncForgetPwd(data);

            if (response.error) {
                // API returned an error
                thunkAPI.dispatch(showToast({ type: "error", msg: response.msg }));
                return thunkAPI.rejectWithValue(response.msg);
            }

            // API call was successful
            thunkAPI.dispatch(showToast({ type: "success", msg: response.msg }));
            return response.msg; // Pass success message to reducer
        } catch (error) {
            const errorMsg = error.response ? error.response.msg : "An error occurred";
            thunkAPI.dispatch(showToast({ type: "error", msg: errorMsg }));
            return thunkAPI.rejectWithValue(errorMsg);
        }
    }
);

export const resetPassword = createAsyncThunk(
    'forgotPassword/resetPassword',
    async (data, thunkAPI) => {

        try {
            const response = await asyncResetPassword(data);
            if (response.error) {
                // API returned an error
                thunkAPI.dispatch(showToast({ type: "error", msg: response.msg }));
                return thunkAPI.rejectWithValue(response.msg);
            }

            thunkAPI.dispatch(showToast({ type: "success", msg: response.msg }));
            return response.msg;
        } catch (error) {
            // Extract error message properly
            let errorMsg = "An error occurred"; // Default message

            if (error.response) {
                if (error.response.data) {
                    errorMsg = error.response.data.msg || error.response.data.error || error.response.data.message || JSON.stringify(error.response.data);
                } else {
                    errorMsg = error.response.statusText || "Server error";
                }
            } else if (error.message) {
                errorMsg = error.message;
            }

            // Show toast notification with the error message
            thunkAPI.dispatch(showToast({ type: "error", msg: errorMsg }));

            return thunkAPI.rejectWithValue(errorMsg);
        }
    }
);
